import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { ApiService } from 'src/app/services/api.service';
import { RouterPreloader, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
 
@Component({
  selector: 'pagamento-confirmacao-page',
  templateUrl: './pagamento-confirmacao-page.component.html',
  styleUrls: ['./pagamento-confirmacao-page.component.scss']
})
export class PagamentoConfirmacaoPage implements OnInit,AfterViewInit {

  public itensBreadcrumbs     = [];
  public dataConfirmacao:any  = null;

  constructor(
    private app: AppService,
    private api: ApiService,
    private router: Router,
    private data: DataService
  ){ }
  

   /**
   * 
   * Set breadcrumbs
   * 
   */
  setItensBreadcrumbs(){

    this.itensBreadcrumbs.push({
      text: "Carrinho",
      routerLink: "/carrinho"
    }); 
    this.itensBreadcrumbs.push({
      text: "Informações do Pagamento" 
    }); 
    this.itensBreadcrumbs.push({
      text: "Confirmação do Pedido"  
    }); 

  }
  /**
   * 
   * Set data confirmacao
   * 
   */
  setDataConfirmacao(){

    this.dataConfirmacao = this.data.getDataConfirmacao();

  }
  /***
   * 
   * Iniciliza as Informações
   * 
   */
  ngOnInit(): void {
    this.setItensBreadcrumbs();
    this.setDataConfirmacao();
  }
  /**
   * 
   * 
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.app.toTop();  
    },500);   
  }

}
